import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, provide, watch } from 'vue'

//echarts
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, BarChart, GaugeChart } from 'echarts/charts'

import {
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  DataZoomComponent,
  MarkLineComponent,
  MarkPointComponent,
} from 'echarts/components'

import VChart, { THEME_KEY } from 'vue-echarts'


export default /*@__PURE__*/_defineComponent({
  __name: 'OxygenChart',
  props: {
  oxygen: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props

// echarts
use([
  LineChart,
  BarChart,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  DataZoomComponent,
  TransformComponent,
  MarkLineComponent,
  MarkPointComponent,
  GaugeChart,
  CanvasRenderer,
])

provide(THEME_KEY, 'light')

const option = ref({
  series: [
    {
      type: 'gauge',
      center: ['50%', '60%'],
      startAngle: 200,
      endAngle: -20,
      min: 0,
      max: 25,
      splitNumber: 5,
      itemStyle: {
        color: '#4CAF50',
      },
      progress: {
        show: true,
        width: 15,
      },
      pointer: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          width: 15,
        },
      },
      axisTick: {
        distance: -25,
        splitNumber: 5,
        lineStyle: {
          width: 1,
          color: '#999',
        },
      },
      splitLine: {
        distance: -30,
        length: 8,
        lineStyle: {
          width: 2,
          color: '#999',
        },
      },
      axisLabel: {
        distance: -15,
        color: '#999',
        fontSize: 10,
      },
      anchor: {
        show: false,
      },
      title: {
        show: false,
      },
      detail: {
        valueAnimation: true,
        width: '50%',
        lineHeight: 30,
        borderRadius: 5,
        offsetCenter: [0, '-20%'],
        fontSize: 18,
        fontWeight: 'bolder',
        formatter: '{value}%',
        color: 'inherit',
      },
      data: [
        {
          value: props.oxygen,
        },
      ],
    },
  ],
})

const chartRef = ref<InstanceType<typeof VChart> | null>(null)

const updateItemStyleGradient = (oxygen: number) => {
  // Función para determinar el color basado en el oxígeno (rango típico del suelo: 10-21%)
  const getColorForOxygen = (oxy: number): string => {
    if (oxy < 10) {
      return '#FF5722' // Rojo para oxígeno muy bajo (anóxico)
    } else if (oxy < 15) {
      return '#FF9800' // Naranja para oxígeno bajo
    } else if (oxy < 18) {
      return '#4CAF50' // Verde para oxígeno óptimo
    } else if (oxy < 21) {
      return '#2196F3' // Azul para oxígeno alto
    } else {
      return '#9C27B0' // Púrpura para oxígeno muy alto
    }
  }

  const newColor = getColorForOxygen(oxygen)
  option.value.series[0].itemStyle.color = newColor
}

watch(
  () => props.oxygen,
  (newOxygen) => {
    option.value.series[0].data[0].value = newOxygen
    updateItemStyleGradient(newOxygen)
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VChart), {
    ref_key: "chartRef",
    ref: chartRef,
    class: "chart",
    option: option.value,
    style: {"height":"200px","width":"100%"}
  }, null, 8, ["option"]))
}
}

})